<template>
    <div class="modal fade" id="editHouseItemsModal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog" style="min-width: 90%; height: 90vh;" role="document">
            <div class="dismiss-modal-btn" @click="dismissModal()">
                <i class="fad fa-times-circle"></i>
            </div>
            <div class="modal-content" style="min-width: 90%; height: 90vh;">
                <section class="project-step" v-if="model">
                    <div class="modal-header">
                        <h5 class="modal-title">Modifica disponibilitate - {{ model.rooms_count ? model.rooms_count.name : '' }} tip {{model.model_type}}</h5>
                    </div>
                    <div class="container-fluid modal-body custom-edit-modal-content" id="edit_house_modal_content">
                        <div class="custom-container">
                            <div class="secondary-heading">
                                <div class="secondary-heading-icon">
                                    <i class="fad fa-building"></i>
                                </div>
                                <span> Adauga Case </span>
                                <div class="add-field-btn"
                                     @click="addItemRow()">
                                    <i class="fad fa-plus-circle"></i>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                                    <p class="custom-input-error" id="general_error"></p>
                                </div>
                                <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                                    <div class="blocks-tabs-content tab-content">
                                        <div class="levels-container">
                                            <div class="single-level-row" :class="{highlighted:itemRow.highlighted}"
                                                 v-for="(itemRow, indexItem) in houses" :key="indexItem">
                                                <div class="row">
                                                    <div class="item-nr-crt">
                                                        <p class=""> {{indexItem+1}}</p>
                                                        <input type="hidden" name="nr_crt" :value="indexItem+1" />
                                                        <input type="hidden" name="id" :value="indexItem+1" />
                                                    </div>
                                                    <div class="col-xl-1 col-lg-1 col-md-6 col-sm-12">
                                                        <div class="level-item-nr level-strip-cell">
                                                            <p class="level-cell-heading"> Nr. Casa </p>
                                                            <div class="input-container">
                                                                <div class="input-group">
                                                                    <input type="text" v-model="itemRow.houseNumber">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-xl-5 col-lg-5 col-md-6 col-sm-12">
                                                        <p class="level-cell-heading"> Suprafata(m²) </p>
                                                        <div class="custom-surface-col">
                                                            <div class="level-item-size level-strip-cell">
                                                                <div class="input-container">
                                                                    <div class="input-group mg-b">
                                                                        <input type="number"
                                                                               v-model="itemRow.usefulSurface">
                                                                        <span> Totala </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="level-item-size level-strip-cell">
                                                                <div class="input-container">
                                                                    <div class="input-group mg-b">
                                                                        <input type="number"
                                                                               v-model="itemRow.terraceSurface">
                                                                        <span> Balcon </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="level-item-size level-strip-cell">
                                                                <div class="input-container">
                                                                    <div class="input-group mg-b">
                                                                        <input type="number"
                                                                               v-model="itemRow.gardenSurface">
                                                                        <span> Teren </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-xl-2 col-lg-2 col-md-6 col-sm-12">
                                                        <div class="level-item-size level-strip-cell">
                                                            <p class="level-cell-heading"> * Pret </p>
                                                            <div class="input-container">
                                                                <div class="input-group mg-b">
                                                                    <input type="number" v-model="itemRow.price">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-xl-2 col-lg-2 col-md-6 col-sm-12">
                                                        <div class="level-item-size level-strip-cell">
                                                            <p class="level-cell-heading"> Pret cu credit </p>
                                                            <div class="input-container">
                                                                <div class="input-group mg-b">
                                                                    <input type="number" v-model="itemRow.credit_price">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-xl-2 col-lg-2 col-md-6 col-sm-12">
                                                        <div class="level-item-size level-strip-cell">
                                                            <p class="level-cell-heading"> * Status </p>
                                                            <div class="input-container">
                                                                <div class="input-group mg-b">
                                                                    <select name="rooms" v-model="itemRow.status">
                                                                        <option value="available"> Disponibil</option>
                                                                        <option value="reserved"> Rezervat</option>
                                                                        <option value="sold"> Vandut</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-xl-2 col-lg-2 col-md-6 col-sm-12">
                                                        <div class="level-item-size level-strip-cell">
                                                            <p class="level-cell-heading"> Data Finalizare </p>
                                                            <div class="input-container">
                                                                <div class="input-group mg-b">
                                                                    <input type="text" v-model="itemRow.finalizedAt">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="single-level-row-availability">
                                                    <div class="general-check step-check">
                                                        <input type="checkbox" v-model="itemRow.showStatusForClients"
                                                               :id="`clients_availability${indexItem}`"
                                                               class="custom-checkbox">
                                                        <label :for="`clients_availability${indexItem}`"
                                                               class="custom-checkbox-label">
                                                            <span></span>
                                                            <p>
                                                                Vizibil pentru clienti
                                                            </p>
                                                        </label>
                                                    </div>
<!--                                                    <div class="general-check step-check">-->
<!--                                                        <input type="checkbox" v-model="itemRow.showStatusForAgencies"-->
<!--                                                               :id="`agents_availability${indexItem}`"-->
<!--                                                               class="custom-checkbox">-->
<!--                                                        <label :for="`agents_availability${indexItem}`"-->
<!--                                                               class="custom-checkbox-label">-->
<!--                                                            <span></span>-->
<!--                                                            <p>-->
<!--                                                                Vizibil pentru agenti-->
<!--                                                            </p>-->
<!--                                                        </label>-->
<!--                                                    </div>-->
                                                </div>
                                                <div class="remove-field-btn">
                                                    <i class="fad fa-minus-circle"
                                                       v-on:click="removeItemRow(indexItem)"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer custom-edit-modal-footer">
                        <div class="center-content mt-3 save-btn">
                            <button type="button" class="general-btn positive-btn" @click="save()">
                                <i class="fad fa-save"></i>
                                <span> Salveaza </span>
                            </button>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>

<script>

  export default {
    name: "DeveloperEditHouseItems",
    data() {
      return {
        model: null,
        project: null,
        houses: [],
        housesDefault: [],
        counter: 0
      }
    },
    async mounted() {
      let vm = this
      $('#editHouseItemsModal').on('hidden.bs.modal', function () {
        vm.model = null
        vm.project = null
        vm.housesDefault = []
        vm.houses = []
        vm.selected = []
        vm.counter = 0
        vm.toEditItemId = 0
      });
      this.$eventBus.$on('OPEN_EDIT_HOUSE_ITEMS_MODAL',async function (payLoad) {
        vm.triggerLoader(true)
        await vm.getModelData(payLoad.modelId,payLoad.itemId)
        vm.triggerLoader(false)
        $('#editHouseItemsModal').modal('show')
      });
    },
    methods: {
      dismissModal() {
          $('#editHouseItemsModal').modal('hide')
      },
      increaseCounter(indexBuilding, indexLevel, indexItem) {
        let counter = 1;
        for (let i = 0; i < indexLevel; i++) {
          counter += this.selected[indexBuilding].selectedLevels[i].itemRows.length;
        }
        this.selected[indexBuilding].selectedLevels[indexLevel].itemRows[indexItem].nrCrt = counter + indexItem;
        return counter + indexItem;
      },
      addItemRow: function () {
        this.houses.push({
          id: null,
          nrCrt: this.houses.length + 1,
          houseNumber: '',
          usefulSurface: this.model.useful_surface,
          terraceSurface: this.model.terrace_surface,
          gardenSurface: this.model.garden_surface,
          price: this.model.price,
          credit_price: this.model.credit_price,
          status: 'available',
          showStatusForClients: true,
          showStatusForAgencies: false,
          finalizedAt: ''
        });
      },
      removeItemRow: function (index) {
        this.houses.splice(index, 1);
      },
      save() {
        let vm = this
        vm.triggerLoader(true)
        window.axios.post(`/developer/model-houses-items-edit/${this.model.id}`, this.houses)
          .then(function () {
            vm.triggerLoader(false)
            // vm.$eventBus.$emit('MODEL_ITEMS_CHANGED');
            window.Swal.fire({
              html: 'Casele au fost editate cu succes',
              icon: 'success',
              timer: 2000,
              showCancelButton: false,
              showConfirmButton: false
            }).then(() => {
              $('#editHouseItemsModal').modal('hide');
            }).then(() => {
              window.location.href = window.location.pathname + '?tab=house';
            })
          })
          .catch(function (err) {
            vm.triggerLoader(false)
            window.showError(err)
          });
      },
      async getModelData(modelId, itemId=null) {
        let vm = this
        vm.triggerLoader(true)
        this.toEditItemId = itemId
        window.axios.get(`/developer/model-data-edit/${modelId}`)
          .then(function (resp) {
            vm.triggerLoader(false)
            vm.model = resp.data.data.model
            vm.project = resp.data.data.model.project
            vm.housesDefault = resp.data.data.model.items
            vm.formatHouses()
          })
          .catch(function () {
            vm.triggerLoader(false)
            // console.log(err)
            // window.showError(err)
          });
      },
      async formatHouses() {
        let vm = this
        await this.housesDefault.forEach(function (item) {
          vm.houses.push({
            id: item.id,
            nrCrt: vm.houses.length + 1,
            houseNumber: item.apartment_number,
            usefulSurface: item.useful_surface,
            terraceSurface: item.terrace_surface,
            gardenSurface: item.garden_surface,
            price: item.price,
            credit_price: item.credit_price,
            status: item.status,
            showStatusForClients: !!item.show_status_for_clients,
            showStatusForAgencies: !!item.show_status_for_agencies,
            finalizedAt: item.finalized_at,
            highlighted: item.id === vm.toEditItemId
          })
        })
        setTimeout(function () {
          var scrollElem = document.getElementsByClassName("highlighted")[0]
          scrollElem.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"})
        }, 500)
      }
    }
  }
</script>
